module.exports = __webpack_public_path__ + "static/media/mindy_sitting_patient.a37ebc1f.png";